<template>
  <v-dialog v-model="open">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>{{
        t("configuracoesDeVoz")
      }}</v-card-title>
      <v-card-text>
        <v-select
          v-model="config.inputDevice"
          :items="inputDevices"
          :label="t('DispositivoDeEntrada')"
          :rules="[(v) => !!v || t('fraseCampoObrigatorio')]"
          required
        ></v-select>
        <v-select
          v-model="config.outputDevice"
          :items="outputDevices"
          :label="t('DispositivoDeSaida')"
          :rules="[(v) => !!v || t('fraseCampoObrigatorio')]"
          required
        ></v-select>
        <v-select
          v-model="config.ringDevice"
          :items="outputDevices"
          :label="t('DispositivoDeAlarme')"
          :rules="[(v) => !!v || t('fraseCampoObrigatorio')]"
          required
        ></v-select>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="cancelar()">Cancelar</v-btn>
        <v-btn color="primary" text @click="setDevices()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
   
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
export default {
  name: "Transferencia",
  props: {
    open: { type: Boolean, default: false },
    inputDevices: { type: Array, default: [] },
    outputDevices: { type: Array, default: [] },
  },
  data() {
    return {
      instancia: null,
      valid: false,
      whatsForm: {
        numero: null,
        queue: null,
        instancia: null,
        nome: null,
      },
      filas: [],
      filasAgente: [],
      snackbar: false,
      snackbarText: null,
      config: JSON.parse(localStorage.getItem("config")),
    };
  },
  watch: {},
  created() {
    // if(this.token) this.$router.push("/main");
  },
  computed: {
    ...mapState("xc", {
      cliente: (state) => state.cliente,
      agentes: (state) => state.agentes,
      atendimento: (state) => state.atendimento,
    }),
    ...mapState("auth", {
      user: (state) => state.user,
    }),
    chamando: function () {
      return document.getElementById("chamando");
    },
    tocando: function () {
      return document.getElementById("tocando");
    },
  },

  methods: {
    ...mapActions("xc", [
      "getDefault",
      "updateCliente",
      "transfereAtendimento",
      "setTransferenciaModal",
      "newWhatsApp",
    ]),
    ...mapActions("sip", ["changeDevices"]),

    setDevices() {
      localStorage.setItem("config", JSON.stringify(this.config));
      this.changeDevices(this.config);
      let ringDevice = this.config.ringDevice
        ? this.config.ringDevice
        : `default`;
      let outputDevice = this.config.outputDevice
        ? this.config.outputDevice
        : `default`;
      //Vamos setar o audio nas tags
      this.tocando.setSinkId(ringDevice);
      this.chamando.setSinkId(outputDevice);
      this.$emit("update", false);
    },
    cancelar() {
      this.$emit("update", false);
    },
  },
};
</script>
<style>
</style>